// extracted by mini-css-extract-plugin
export var wrapper = "display-module--wrapper--vQ0g8";
export var errorColor = "display-module--errorColor--hmFdv";
export var loader = "display-module--loader--l+I15";
export var spin = "display-module--spin--WmLbN";
export var title = "display-module--title--hrIS-";
export var boxWrapper = "display-module--box-wrapper--NFgAS";
export var box = "display-module--box--yF3ZX";